import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const continuitySearchSchema = z.object({
  tab: z.enum(['bia', 'bcp']).optional(),
});

export const Route = createFileRoute('/_authenticated/bcp/continuity')({
  validateSearch: continuitySearchSchema,
  beforeLoad: ({ search }) => {
    // Preserve existing deep-links while routing to dedicated tab paths.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: search.tab === 'bcp' ? '/bcp/bcp' : '/bcp/bia', replace: true });
  },
  component: ContinuityCompatibilityRedirect,
});

function ContinuityCompatibilityRedirect() {
  return null;
}
